/* eslint-disable prefer-const */
/* eslint-disable quotes */
import React, { useCallback, useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';

// import GenericInfiniteScroll from 'components/atoms/list/GenericInfiniteScroll';
// import { DynamicFormattedMessage } from 'components/atoms/ui/DynamicFormattedMessage';
// import PointConversionsHeader from 'components/molecules/wall/pointConversions/PointConversionsHeader';
// import ValidatePointConversionModal from 'components/organisms/modals/ValidatePointConversionModal';
// import PointConversionRow from 'components/organisms/wall/pointConversions/PointConversionRow';
import {
  DEFAULT_POINT_CONVERSION_STATUS_ERROR,
  DEFAULT_POINT_CONVERSION_STATUS_PENDING,
  HTML_TAGS,
  LOADER_TYPE
} from 'constants/general';
// import { VALIDATE_POINT_CONVERSION_MODAL } from 'constants/modal';
import { POINT_CONVERSION_HEADERS } from 'constants/wall/users';
// import { setModalState } from 'store/actions/modalActions';

import tableStyle from 'sass-boilerplate/stylesheets/components/tables/Table.module.scss';
import coreStyle from 'sass-boilerplate/stylesheets/style.module.scss';
// import grid from 'sass-boilerplate/stylesheets/vendors/bootstrap-grid.module.scss';
import SearchableFilterSelect from 'components/atoms/ui/SearchableFilterSelect';
import { useIntl } from 'react-intl';
import pointsStyle from 'sass-boilerplate/stylesheets/components/launch/Points.module.scss';
// import { ProductFromCatalogue } from 'api/huuray/models/ProductFromCatalogue';
import { IPointsConverion, PointsOption } from 'interfaces/components/wall/Ipoints';
// import { tr } from 'date-fns/locale';
import { ColDef, GridReadyEvent, IDateFilterParams, CellClassParams, RowClassParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import 'ag-grid-community/styles/ag-grid.css'; // Core CSS
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Theme
import Loading from 'components/atoms/ui/Loading';
import { BUTTON_MAIN_TYPE, BUTTON_MAIN_VARIANT } from 'constants/ui';
import ButtonFormatted from 'components/atoms/ui/ButtonFormatted';
import CustomPointsTooltip from './CustomPointsTooltip';
import Button from 'components/atoms/ui/Button';
import { HuurayResolutionModal, isReservedConversion } from './HuurayResolutionModal';
import bdcModalStyle from 'assets/style/components/BDC/BdcWinsDemandModal.module.scss';
// import ReactTooltip from 'react-tooltip';
// import { TOOLTIP_FIELDS } from 'constants/tootltip';

/**
 * Renders the list of point conversions
 *
 * @param hasMore
 * @param loadMore
 * @param scrollRef
 * @param isLoading
 * @param pointsConversions
 * @param listCriteria
 * @param onSort
 * @param onValidateSuccess
 * @constructor
 */
export const PointConversionsList = ({
  hasMore,
  loadMore,
  scrollRef,
  isLoading,
  pointsConversions,
  listCriteria,
  onSort,
  onValidateSuccess,
  setDataExport,
  setExportColDefs,
  setFileName,
  canResolve = true
}) => {
  // const dispatch = useDispatch();
  const {
    textCenter,
    withDangerColor,
    mt2,
    text1Xs,
    pointer,
    secondaryColor,
    withAlertColor,
    withBoldFont
  } = coreStyle;
  const { tableRowHoverUser, tableUsers } = tableStyle;
  const [selectedListBrandName, setSelectedListBrandName] = useState < PointsOption[] > ([]);
  const [selectedListStatus, setSelectedListStatus] = useState < PointsOption[] > ([]);
  const [selectedListColumns, setSelectedListColumns] = useState < PointsOption[] > ([]);
  const [selectedListName, setSelectedListName] = useState < PointsOption[] > ([]);
  const [selectedListPlatform, setSelectedListPlatform] = useState < PointsOption[] > ([]);
  const [selectedListProgram, setSelectedListProgram] = useState < PointsOption[] > ([]);
  const [brandNameOptions, setBrandNameOptions] = useState < PointsOption[] > ([]);
  const [platformOptions, setPlatformOptions] = useState < PointsOption[] > ([]);
  const [programOptions, setProgramOptions] = useState < PointsOption[] > ([]);
  const [columnsOptions, setColumnsOptions] = useState < PointsOption[] > ([]);
  const [statusOptions, setStatusOptions] = useState < PointsOption[] > ([]);
  const [filtredData, setFiltredData] = useState < IPointsConverion[] > ([]);
  const [selectedRow, setSelectedRow] = useState < IPointsConverion > ({});
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [colFiledData, setColFiledData] = useState('');
  const [selectedRowId, setSelectedRowId] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const { formatMessage } = useIntl();
  const [dataToCopy, setDataToCopy] = useState('');
  const [colDefs, setColDefs] = useState([]);
  const [resolutionConversion, setResolutionConversion] = useState<IPointsConverion | null>(null);

  // const onValidateRow = pointConversion => {
  //   dispatch(setModalState(true, VALIDATE_POINT_CONVERSION_MODAL, { pointConversion }));
  // };

  const multiFilterData = (selectedList: PointsOption[], selectedItem: PointsOption) => {
    if (selectedItem.isBrandName) setSelectedListBrandName(selectedList);
    else if (selectedItem.isStatus) setSelectedListStatus(selectedList);
    else if (selectedItem.isPlatform) setSelectedListPlatform(selectedList);
    else if (selectedItem.isProgram) setSelectedListProgram(selectedList);
  };

  useEffect(() => {
    if (!pointsConversions) return;
    let filtered = pointsConversions;
    if (selectedListPlatform.length) filtered = filtered.filter(row =>
      selectedListPlatform.some(option => row.platform?.id === option.value));
    if (selectedListProgram.length) filtered = filtered.filter(row =>
      selectedListProgram.some(option => row.program?.id === option.value));
    if (selectedListBrandName.length) filtered = filtered.filter(row =>
      selectedListBrandName.some(option => String(row.brandName || '').includes(String(option.value))));
    if (selectedListStatus.length) filtered = filtered.filter(row => selectedListStatus.some(option =>
      option.value === 'reserved' ? isReservedConversion(row)
        : row.status === option.value && (Number(option.value) !== 2 || !isReservedConversion(row))));
    setFiltredData(filtered);
  }, [pointsConversions, selectedListPlatform, selectedListProgram, selectedListBrandName, selectedListStatus]);

  const setFiltersdata = async () => {
    let status = [];
    let brandNames = [];
    let platforms = [];
    let programs = [];
    pointsConversions.forEach((element: IPointsConverion) => {
      if (
        (brandNames.length == 0 || !brandNames.some(e => e.value == element.brandName || element.brandName == '')) &&
        element.brandName &&
        element.brandName != '' &&
        element.brandName != ' '
      ) {
        brandNames.push({
          value: element.brandName,
          label: element.brandName,
          color: '',
          isFixed: false,
          isDisabled: false,
          isBrandName: true
        });
      }
      const statusValue = isReservedConversion(element) ? 'reserved' : element.status;
      if ((status.length == 0 || !status.some(e => e.value == statusValue)) && element.status) {
        status.push({
          value: statusValue,
          label: isReservedConversion(element)
            ? formatMessage({ id: 'pointsConversions.reconciliation.reserved' })
            : formatMessage({ id: `pointConversions.status.${element.status}` }),
          color: '',
          isFixed: false,
          isDisabled: false,
          isStatus: true
        });
      }
      if (
        (platforms.length == 0 || !platforms.some(e => e.value == element.platform.id || element.platform.id == '')) &&
        element.platform.id &&
        element.platform.id != '' &&
        element.platform.id != ' '
      ) {
        platforms.push({
          value: element.platform.id,
          label: element.platform.name,
          color: '',
          isFixed: false,
          isDisabled: false,
          isPlatform: true
        });
      }
      if (
        (programs.length == 0 || !programs.some(e => e.value == element.program.id || element.program.id == '')) &&
        element.program.id &&
        element.program.id != '' &&
        element.program.id != ' '
      ) {
        programs.push({
          value: element.program.id,
          label: element.program.name,
          color: '',
          isFixed: false,
          isDisabled: false,
          isProgram: true
        });
      }
    });
    setBrandNameOptions(brandNames);
    setStatusOptions(status);
    setPlatformOptions(platforms);
    setProgramOptions(programs);
  };
  // const [colDefs, setColDefs] = useState([]);
  const [defaultColDef, setDefaultColDef] = useState({});
  const [gridApi, setGridApi] = useState < any > ({});
  const [columnApi, setColumnApi] = useState < any > ({});
  // const [isTooltipOpen, setIsTooltipOpen] = useState(true);
  const getRowClass = (params: RowClassParams) => {
    return params.node.data.status == 2
      ? `${withBoldFont} ${withDangerColor}`
      : params.node.data.status == 3
        ? `${withBoldFont} ${withAlertColor}`
        : '';
  };
  const setGridColDefs = () => {
    const columns: PointsOption[] = [];
    if (!colDefs || colDefs?.length == 0) {
      const narrow = window.innerWidth <= 600;
      let coldef = [];
      let coldefExp = [];
      setExportColDefs([]);

      POINT_CONVERSION_HEADERS.forEach((col: any) => {
        const obj = {
          field: col.field,
          headerName: formatMessage({ id: col.headerName }),
          pinned: col.field === 'statusName' ? 'right' : col.field === 'name' ? 'left' : undefined,
          minWidth: narrow && col.field === 'name' ? 90 : narrow && col.field === 'statusName' ? 100 : col.minWidth,
          maxWidth: narrow && col.field === 'name' ? 90 : narrow && col.field === 'statusName' ? 100 : col.maxWidth,
          hide: narrow && col.field !== 'name' && col.field !== 'statusName'
        };
        // col.headerName = formatMessage({id: col.headerName});
        // col.cellClass = cellClass;
        const col1 = Object.assign({}, col, {})
        coldefExp.push({
          field: col1.field,
          headerName: formatMessage({ id: col1.headerName })
        });

        coldef.push(obj);
        columns.push({
          label: obj.headerName,
          value: obj.field
        });
      });
      if (canResolve) coldef.push({
        colId: 'resolutionActions',
        headerName: formatMessage({ id: 'pointsConversions.reconciliation.actions' }),
        pinned: 'right',
        width: narrow ? 85 : 150,
        minWidth: narrow ? 85 : 150,
        maxWidth: narrow ? 85 : 150,
        sortable: false,
        filter: false,
        cellRenderer: params => isReservedConversion(params.data) ? (
          <span data-reconciliation-action onClick={event => event.stopPropagation()}>
            <Button type={BUTTON_MAIN_TYPE.PRIMARY_INVERTED} className={bdcModalStyle.paymentActionButton}
              onClick={() => setResolutionConversion(params.data)}>
              {formatMessage({ id: narrow
                ? 'pointsConversions.reconciliation.resolveShort'
                : 'pointsConversions.reconciliation.resolve' })}
            </Button>
          </span>
        ) : null
      });
      const cols = Object.assign([], coldefExp);
      setExportColDefs(cols);

      setColDefs(coldef);
      setDefaultColDef({
        flex: 1,
        minWidth: 110,
        maxWidth: 130,
        resizable: true,
        filter: 'agTextColumnFilter',
        menuTabs: ['filterMenuTab']
      });
      setColumnsOptions(columns);
      setSelectedListColumns(narrow ? columns.filter(col => col.value === 'name' || col.value === 'statusName') : columns);
    } else if (!columnsOptions || columnsOptions?.length == 0) {
      colDefs.forEach((col: any) => {
        columns.push({
          label: col.headerName,
          value: col.field
        });
        setColumnsOptions(columns);
        setSelectedListColumns(columns);
      });
    }
  };

  const performData = () => {
    pointsConversions.map((elem: IPointsConverion) => {
      elem.superplatformName = elem.superplatform.name;
      elem.superPlatformId = elem.superplatform.id;
      elem.platformName = elem.platform.name;
      elem.platformId = elem.platform.id;
      elem.programName = elem.program.name;
      elem.programId = elem.program.id;
      elem.company = elem.program.company;
      elem.statusName = formatMessage({
        id: isReservedConversion(elem)
          ? 'pointsConversions.reconciliation.reserved'
          : `pointConversions.status.${elem.status}`
      });
      return elem;
    });
    const data = Object.assign([], pointsConversions);
    setDataExport(data);
  };

  useEffect(() => {
    performData();
    setFiltredData(pointsConversions);
    setFiltersdata();
    setGridColDefs();
  }, [pointsConversions]);

  /**
   * AG Grid data table
   */

  // const defaultColDef = useMemo(() => {
  //   return {
  //     flex: 1,
  //     minWidth: 150,
  //     filter: 'agTextColumnFilter',
  //     menuTabs: ['filterMenuTab'],
  //   };
  // }, []);
  const onGridReady = useCallback(params => {
    // fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
    //   .then((resp) => resp.json())
    //   .then((data) => setRowData(data));
    if (params) {
      setGridApi(params.api);
      setColumnApi(params.columnApi);
    }
  }, []);

  const resetFilters = () => {
    setSelectedListBrandName([]);
    setSelectedListPlatform([]);
    setSelectedListProgram([]);
    setSelectedListStatus([]);
    setSelectedListColumns([]);
    setTimeout(() => {
      setSelectedListColumns(columnsOptions);
      showAllColumns();
    }, 100);
    // console.log(statusOptions);
    setFiltredData(pointsConversions);
  };

  const onRowClicked = e => {
    if (e?.event?.target?.closest?.('[data-reconciliation-action]')) return;
    const row = e.data;
    let rowData = {};
    colDefs.forEach(col => {
      let key = col.headerName;
      let colField = col.field;
      rowData[key] = row[colField];
    });
    setSelectedRow(rowData);
    const clickedElement = e.event?.target as HTMLElement;
    const colData = clickedElement?.closest?.('.ag-cell')?.textContent?.trim() || clickedElement?.textContent?.trim() || '';
    setColFiledData(colData);
    setPosition({ x: e.event.clientX, y: e.event.clientY });
    setIsVisible(true);
  };

  const changeColumns = (values: PointsOption[]) => {
    setSelectedListColumns(values);
    if (gridApi?.setColumnsVisible) columnsOptions.forEach(option =>
      gridApi.setColumnsVisible([option.value], values.some(value => value.value === option.value)));
  };

  const showAllColumns = () => {
    if (gridApi?.getColumns) gridApi.setColumnsVisible(gridApi.getColumns() || [], true);
  };

  if (isLoading || !pointsConversions) {
    return <Loading type={LOADER_TYPE.PAGE} />;
  }

  if (pointsConversions.length > 0) {
    {
      return (
        <div className={pointsStyle.gridPoints}>
          <div className={pointsStyle.gridPointsFilter}>
            <SearchableFilterSelect options={platformOptions} selectedValues={selectedListPlatform} multiple
              onChange={multiFilterData} placeholder={formatMessage({ id: 'points.filter.platform.placeholder' })} />
            <SearchableFilterSelect options={programOptions} selectedValues={selectedListProgram} multiple
              onChange={multiFilterData} placeholder={formatMessage({ id: 'points.filter.program.placeholder' })} />
            <SearchableFilterSelect options={brandNameOptions} selectedValues={selectedListBrandName} multiple
              onChange={multiFilterData} placeholder={formatMessage({ id: 'points.filter.brandName.placeholder' })} />
          </div>
          <div className={pointsStyle.gridPointsFilter}>
            <SearchableFilterSelect options={statusOptions} selectedValues={selectedListStatus} multiple
              onChange={multiFilterData} placeholder={formatMessage({ id: 'points.filter.status.placeholder' })} />
            <SearchableFilterSelect options={columnsOptions} selectedValues={selectedListColumns} multiple
              onChange={changeColumns} placeholder={formatMessage({ id: 'points.filter.column.placeholder' })} />
            <ButtonFormatted onClick={resetFilters} variant={BUTTON_MAIN_VARIANT.INVERTED}
              type={BUTTON_MAIN_TYPE.PRIMARY} buttonText="btn.label.resetFilters" isLoading={isLoading} />
          </div>
          <div className={`${pointsStyle.gridPointsContent} ag-theme-quartz`}>
            <AgGridReact
              rowData={filtredData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              pagination={true}
              enableBrowserTooltips={true}
              getRowClass={getRowClass}
              tooltipInteraction={true}
              onRowClicked={e => onRowClicked(e)}
              postSortRows={params => {
                params.nodes.sort((left, right) => Number(isReservedConversion(right.data)) - Number(isReservedConversion(left.data)));
              }}
              suppressMenuHide={true}
              sideBar={'columns'}
            />
            <CustomPointsTooltip
              data={selectedRow}
              position={position}
              isVisible={isVisible}
              setIsVisible={setIsVisible}
              dataToCopy={dataToCopy}
              setDataToCopy={setDataToCopy}
              colFiledData={colFiledData}
            />
            {canResolve && <HuurayResolutionModal
              conversion={resolutionConversion}
              onClose={() => setResolutionConversion(null)}
              onValidateSuccess={onValidateSuccess}
            />}
          </div>
        </div>
      );
    }
  }
  return <div>{formatMessage({ id: 'pointConversions.list.none' })}</div>;
};
